import gql from 'graphql-tag';
import { categoryFieldsFragment } from './categoryFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { supplyObjectFieldsFragment } from './supplyObjectFieldsFragment';
import { questionStepFieldsFragment } from './questionStepFieldsFragment';
import { ownerFieldsFragment } from './ownerFieldsFragment';

export const questionFieldsFragment = gql`
  fragment AdminQuestionFields on Question {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    owner {
      ...AdminOwnerFields
    }
    name
    supplies {
      _ref
    }
    categories {
      _ref
    }
    rSupplies {
      ...AdminSupplyObjectFields
    }
    rCategories {
      ...AdminCategoryFields
    }
    preparationInfo {
      _key
      content
    }
    steps {
      ...AdminQuestionStepFields
    }
    options {
      maxTime
    }
    archived
  }

  ${sanityDocumentFieldsFragment}
  ${supplyObjectFieldsFragment}
  ${categoryFieldsFragment}
  ${questionStepFieldsFragment}
  ${ownerFieldsFragment}
`;
